import React, { Fragment } from 'react'
import { Link } from 'react-router-dom'

import PropTypes from 'prop-types'

import './navbar13.css'

const Navbar13 = (props) => {
  return (
    <header className={`navbar13-container1 ${props.rootClassName} `}>
      <header data-thq="thq-navbar" className="navbar13-navbar-interactive">
        <div className="navbar13-container2">
          <a href="#Home" className="navbar13-link7">
            <div className="navbar13-container3">
              <img
                alt={props.imageAlt1}
                src={props.imageSrc1}
                className="navbar13-image"
              />
            </div>
          </a>
        </div>
        <div data-thq="thq-navbar-nav" className="navbar13-desktop-menu">
          <nav className="navbar13-links1">
            <a
              href="https://campflyer.io/home_cn/#feature"
              className="navbar13-link11 thq-body-small thq-link"
            >
              {props.link11}
            </a>
            <a
              href="https://campflyer.io/home_cn/#solution"
              className="navbar13-link21 thq-body-small thq-link"
            >
              {props.link21}
            </a>
            <a
              href="https://campflyer.io/home_cn/#partners"
              className="navbar13-link31 thq-body-small thq-link"
            >
              {props.link33}
            </a>
            <a
              href="https://campflyer.io/home_cn/#pricing"
              className="navbar13-link32 thq-body-small thq-link"
            >
              {props.link34}
            </a>
            <a
              href="https://campflyer.io/home_cn/#team"
              className="navbar13-link41 thq-body-small thq-link"
            >
              {props.link45}
            </a>
          </nav>
          <div className="navbar13-buttons1">
            <a href="https://campflyer.io/" className="navbar13-link8">
              <svg
                width="32"
                height="32"
                viewBox="0 0 32 32"
                className="navbar13-icon10"
              >
                <path
                  d="M18 19h6v2h-6zm0-4h12v2H18zm0-4h12v2H18zm-4 10v-2H9v-2H7v2H2v2h8.215a8.6 8.6 0 0 1-2.216 3.977A9.3 9.3 0 0 1 6.552 23H4.333a10.9 10.9 0 0 0 2.145 3.297A14.7 14.7 0 0 1 3 28.127L3.702 30a16.4 16.4 0 0 0 4.29-2.336A16.5 16.5 0 0 0 12.299 30L13 28.127A14.7 14.7 0 0 1 9.523 26.3a10.3 10.3 0 0 0 2.729-5.3zm-2.833-8h2.166L8.75 2H6.583L2 13h2.166L5 11h5.334zM5.833 9l1.834-4.4L9.5 9z"
                  fill="currentColor"
                ></path>
              </svg>
            </a>
            <a
              href="https://console.campflyer.io/login"
              className="navbar13-action21 thq-button-animated thq-button-outline"
            >
              <span className="navbar13-text1">{props.text}</span>
            </a>
            <a
              href="https://doqqi8stylu.typeform.com/to/zDp1N8uh"
              className="navbar13-action22 thq-button-animated thq-button-outline"
            >
              <span className="navbar13-text2">
                {props.action2 ?? (
                  <Fragment>
                    <span className="navbar13-text5">預約試範</span>
                  </Fragment>
                )}
              </span>
            </a>
          </div>
        </div>
        <div data-thq="thq-burger-menu" className="navbar13-burger-menu">
          <svg viewBox="0 0 1024 1024" className="navbar13-icon12">
            <path d="M128 554.667h768c23.552 0 42.667-19.115 42.667-42.667s-19.115-42.667-42.667-42.667h-768c-23.552 0-42.667 19.115-42.667 42.667s19.115 42.667 42.667 42.667zM128 298.667h768c23.552 0 42.667-19.115 42.667-42.667s-19.115-42.667-42.667-42.667h-768c-23.552 0-42.667 19.115-42.667 42.667s19.115 42.667 42.667 42.667zM128 810.667h768c23.552 0 42.667-19.115 42.667-42.667s-19.115-42.667-42.667-42.667h-768c-23.552 0-42.667 19.115-42.667 42.667s19.115 42.667 42.667 42.667z"></path>
          </svg>
        </div>
        <div data-thq="thq-mobile-menu" className="navbar13-mobile-menu">
          <div className="navbar13-nav">
            <div className="navbar13-top">
              <Link to="/" className="navbar13-navlink">
                <img
                  alt={props.logoAlt}
                  src={props.logoSrc}
                  className="navbar13-logo"
                />
              </Link>
              <div data-thq="thq-close-menu" className="navbar13-close-menu">
                <svg viewBox="0 0 1024 1024" className="navbar13-icon14">
                  <path d="M810 274l-238 238 238 238-60 60-238-238-238 238-60-60 238-238-238-238 60-60 238 238 238-238z"></path>
                </svg>
              </div>
            </div>
            <nav className="navbar13-links2">
              <a
                href="https://campflyer.io/home_cn/#feature"
                className="navbar13-link12 thq-body-small thq-link"
              >
                {props.link12}
              </a>
              <a
                href="https://campflyer.io/home_cn/#solution"
                className="navbar13-link22 thq-body-small thq-link"
              >
                {props.link22}
              </a>
              <a
                href="https://campflyer.io/home_cn/#partners"
                className="navbar13-link33 thq-body-small thq-link"
              >
                {props.link35}
              </a>
              <a
                href="https://campflyer.io/home_cn/#pricing"
                className="navbar13-link34 thq-body-small thq-link"
              >
                {props.link36}
              </a>
              <a
                href="https://campflyer.io/home_cn/#team"
                className="navbar13-link42 thq-body-small thq-link"
              >
                {props.link46}
              </a>
              <a
                href="https://campflyer.io/terms"
                className="navbar13-link5 thq-body-small thq-link"
              >
                {props.link5}
              </a>
              <a
                href="https://campflyer.io/privacy"
                className="navbar13-link6 thq-body-small thq-link"
              >
                {props.link6}
              </a>
            </nav>
            <div className="navbar13-buttons2">
              <a
                href="https://console.campflyer.io/login"
                className="navbar13-action23 thq-button-animated thq-button-outline"
              >
                <span className="navbar13-text3">{props.text3}</span>
              </a>
              <a
                href="https://doqqi8stylu.typeform.com/to/zDp1N8uh"
                className="navbar13-action24 thq-button-animated thq-button-outline"
              >
                <span className="navbar13-text4">{props.text4}</span>
              </a>
              <a href="https://campflyer.io/" className="navbar13-link9">
                <svg
                  width="32"
                  height="32"
                  viewBox="0 0 32 32"
                  className="navbar13-icon16"
                >
                  <path
                    d="M18 19h6v2h-6zm0-4h12v2H18zm0-4h12v2H18zm-4 10v-2H9v-2H7v2H2v2h8.215a8.6 8.6 0 0 1-2.216 3.977A9.3 9.3 0 0 1 6.552 23H4.333a10.9 10.9 0 0 0 2.145 3.297A14.7 14.7 0 0 1 3 28.127L3.702 30a16.4 16.4 0 0 0 4.29-2.336A16.5 16.5 0 0 0 12.299 30L13 28.127A14.7 14.7 0 0 1 9.523 26.3a10.3 10.3 0 0 0 2.729-5.3zm-2.833-8h2.166L8.75 2H6.583L2 13h2.166L5 11h5.334zM5.833 9l1.834-4.4L9.5 9z"
                    fill="currentColor"
                  ></path>
                </svg>
              </a>
            </div>
          </div>
          <div className="navbar13-icon-group">
            <svg
              viewBox="0 0 950.8571428571428 1024"
              className="thq-icon-x-small"
            >
              <path d="M925.714 233.143c-25.143 36.571-56.571 69.143-92.571 95.429 0.571 8 0.571 16 0.571 24 0 244-185.714 525.143-525.143 525.143-104.571 0-201.714-30.286-283.429-82.857 14.857 1.714 29.143 2.286 44.571 2.286 86.286 0 165.714-29.143 229.143-78.857-81.143-1.714-149.143-54.857-172.571-128 11.429 1.714 22.857 2.857 34.857 2.857 16.571 0 33.143-2.286 48.571-6.286-84.571-17.143-148-91.429-148-181.143v-2.286c24.571 13.714 53.143 22.286 83.429 23.429-49.714-33.143-82.286-89.714-82.286-153.714 0-34.286 9.143-65.714 25.143-93.143 90.857 112 227.429 185.143 380.571 193.143-2.857-13.714-4.571-28-4.571-42.286 0-101.714 82.286-184.571 184.571-184.571 53.143 0 101.143 22.286 134.857 58.286 41.714-8 81.714-23.429 117.143-44.571-13.714 42.857-42.857 78.857-81.143 101.714 37.143-4 73.143-14.286 106.286-28.571z"></path>
            </svg>
            <svg
              viewBox="0 0 877.7142857142857 1024"
              className="thq-icon-x-small"
            >
              <path d="M585.143 512c0-80.571-65.714-146.286-146.286-146.286s-146.286 65.714-146.286 146.286 65.714 146.286 146.286 146.286 146.286-65.714 146.286-146.286zM664 512c0 124.571-100.571 225.143-225.143 225.143s-225.143-100.571-225.143-225.143 100.571-225.143 225.143-225.143 225.143 100.571 225.143 225.143zM725.714 277.714c0 29.143-23.429 52.571-52.571 52.571s-52.571-23.429-52.571-52.571 23.429-52.571 52.571-52.571 52.571 23.429 52.571 52.571zM438.857 152c-64 0-201.143-5.143-258.857 17.714-20 8-34.857 17.714-50.286 33.143s-25.143 30.286-33.143 50.286c-22.857 57.714-17.714 194.857-17.714 258.857s-5.143 201.143 17.714 258.857c8 20 17.714 34.857 33.143 50.286s30.286 25.143 50.286 33.143c57.714 22.857 194.857 17.714 258.857 17.714s201.143 5.143 258.857-17.714c20-8 34.857-17.714 50.286-33.143s25.143-30.286 33.143-50.286c22.857-57.714 17.714-194.857 17.714-258.857s5.143-201.143-17.714-258.857c-8-20-17.714-34.857-33.143-50.286s-30.286-25.143-50.286-33.143c-57.714-22.857-194.857-17.714-258.857-17.714zM877.714 512c0 60.571 0.571 120.571-2.857 181.143-3.429 70.286-19.429 132.571-70.857 184s-113.714 67.429-184 70.857c-60.571 3.429-120.571 2.857-181.143 2.857s-120.571 0.571-181.143-2.857c-70.286-3.429-132.571-19.429-184-70.857s-67.429-113.714-70.857-184c-3.429-60.571-2.857-120.571-2.857-181.143s-0.571-120.571 2.857-181.143c3.429-70.286 19.429-132.571 70.857-184s113.714-67.429 184-70.857c60.571-3.429 120.571-2.857 181.143-2.857s120.571-0.571 181.143 2.857c70.286 3.429 132.571 19.429 184 70.857s67.429 113.714 70.857 184c3.429 60.571 2.857 120.571 2.857 181.143z"></path>
            </svg>
            <svg
              viewBox="0 0 602.2582857142856 1024"
              className="thq-icon-x-small"
            >
              <path d="M548 6.857v150.857h-89.714c-70.286 0-83.429 33.714-83.429 82.286v108h167.429l-22.286 169.143h-145.143v433.714h-174.857v-433.714h-145.714v-169.143h145.714v-124.571c0-144.571 88.571-223.429 217.714-223.429 61.714 0 114.857 4.571 130.286 6.857z"></path>
            </svg>
          </div>
        </div>
      </header>
    </header>
  )
}

Navbar13.defaultProps = {
  logoSrc: '/re%20(7)-1500h.png',
  link35: '客戶評語',
  link11: '為何用 Campflyer',
  text: '登入',
  action2: undefined,
  link5: '條款',
  link6: '私隱',
  text4: '預約試範',
  link36: '收費',
  logoAlt: 'logo',
  link45: '關於我們',
  link33: '客戶評語',
  link34: '收費\n',
  text3: '登入',
  link22: '方案',
  rootClassName: '',
  imageSrc1: '/re%20(7)-1500h.png',
  link21: '方案',
  link46: '關於我們',
  imageAlt1: 'image',
  link12: '為何用 Campflyer',
}

Navbar13.propTypes = {
  logoSrc: PropTypes.string,
  link35: PropTypes.string,
  link11: PropTypes.string,
  text: PropTypes.string,
  action2: PropTypes.element,
  link5: PropTypes.string,
  link6: PropTypes.string,
  text4: PropTypes.string,
  link36: PropTypes.string,
  logoAlt: PropTypes.string,
  link45: PropTypes.string,
  link33: PropTypes.string,
  link34: PropTypes.string,
  text3: PropTypes.string,
  link22: PropTypes.string,
  rootClassName: PropTypes.string,
  imageSrc1: PropTypes.string,
  link21: PropTypes.string,
  link46: PropTypes.string,
  imageAlt1: PropTypes.string,
  link12: PropTypes.string,
}

export default Navbar13
